// routes name
export const homepageURL = "/";
// export const homepageURL2 = "/v2";
export const aboutUsURL = "/about-us";
export const aboutUsURLV2 = "/about-us-v2";
export const datatypesURL = "/data-types";
export const datatypesLightThemeURL = "/data-types-light-theme";
export const comingsoonURL = "/coming-soon";
export const privacypolicyURL = "/privacy-policy";
export const termsandconditionURL = "/terms-and-conditions";
export const contactUsURL = "/contact-us";
// feedback form integration -- Upamanyu
export const feedbackURL = "/feedback";
export const businessFeedbackURL = "/business-feedback";
export const faqsURL = "/faqs";
export const BlogsListingURL = "/blogs";
export const BlogsInnerURL = "/blog-inner";

// Login flow
export const loginURL = "/login";
export const loginOtpURL = "/login/otp";
export const resetPassURL = "/reset-password";
export const designAssistantLoginURL = "/design-assistant/login";
export const designAssistantLoginOtpURL = "/design-assistant/login/otp";

// Early access form path
export const registrationFormURL = "/register/personal/basic-details";
export const accountCategoryURL = "/register";
export const regiserOTPURL = "/register/personal/otp";
export const congratulationsURL = "/register/personal/congrats";
export const congratulationsLightURL = "/register/congrats-light";
export const businessPaymentSuccessURL = "/business/payment-success";
export const waitScreenUrl = "/register/wait-screen";

// Business form flow
export const registrationBusinessURL = "https://business.archinza.com"; //business registration - external
export const registrationBusinessPath = "/register/business/basic-details"; //business registration form (internal route path)
export const registrationBusinessOTPURL = "/register/business/otp";
export const businessFormFiveLTURL = "/business/business-details"; //step form
export const businessProfileURL = "/business/edit-profile-old";
export const businessProfileEditURL = "/business/edit-profile-v2";
export const businessProfileEditURL2 = "/business/edit-profile";
export const businessProfileViewURL = "/business/view-profile";
export const businessProfileViewURL2 = "/business/view-profile-rishi";
export const businessProfileViewURL3 = "/business/profile/:username";
export const businessConnectViwUrl = "/business/business-connect";
export const businessConnectEditUrl = "/business/business-connect-edit";

// Dashboard paths
export const dashboardURL = "/dashboard";
export const changeRoleURL = "/change-role";

// Profile paths
export const editProfile = "/edit-profile";
export const editProfileBusiness = "/edit-profile-business";

// Early access forms
export const proAccessURL = "/pro-access";
export const teamAccesssURL = "/team-member-access";
export const businessAccessURL = "/business-access";
export const businessFormFiveURL = "/business-form";

// Social links
export const facebookURL =
  "https://www.facebook.com/profile.php?id=100091559990889";
export const instagramURL = "https://www.instagram.com/archin.za/";
export const linkedinURL = "https://www.linkedin.com/company/archinza/";
export const pinterestURL = "https://in.pinterest.com/archinza01/";

//Demo page links
export const businessOwner = "/bfo";
export const designEnthusiast = "/de";

//Plan pages links
export const planDetails = "/business/plan-details";
export const chooseYourPlan = "/business/choose-your-plan";
export const invoiceUrl = "/invoice/print/:invoiceId";

export const pricingPlansURL = "/pricing-plans";

// Client Code
export const clientBusiness = "/business";
export const clientPersonal = "/personal";
export const businessMagicLogin = "/business/magic-login";
export const personalMagicLogin = "/personal/magic-login";

// Special payments
export const specialPaymentsURL = "/special-payments";
export const specialCheckoutURL = "/special-checkout/:token";


